import { Box, Button, IconButton, Menu, MenuItem, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../components/SearchBar';
import TableComponent from '../../components/TableComponent';
import { showToast } from '../../constants/toasts';
import { errorToast, successToast } from '../../helpers';
import MainContainer from '../../layout/MainContainer';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import {
  useDeletePromoCodeMutation,
  useLazyGetPromoCodeQuery,
  useUpdatePromoCodeMutation,
} from '../../service/promoCode';
import { CommonBody, PromoCode } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { DISCOUNT_TYPE_NAME } from '../../utils/enums';
import { isValidInput } from '../../utils/validations';

const ManagePromoCodes = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>('');
  const [totalCount, setTotalCount] = useState<number>();
  const [page, setPage] = useState<number>(1);
  const [data, setData] = useState<PromoCode[]>([]);
  const [selectedId, setSelectedId] = useState<string>('');
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openDetail, setOpenDetail] = useState(false);

  const [hidden, setHidden] = useState<string[]>([]);
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);

  const [getPromoCode] = useLazyGetPromoCodeQuery();
  const [updatePromoCode] = useUpdatePromoCodeMutation();
  const [deletePromoCode] = useDeletePromoCodeMutation();

  const handleClose = () => {
    setOpenDetail(false);
  };

  const open1 = Boolean(anchorEl1);

  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };
  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const rows = [
    {
      id: 1,
      name: 'WELCOME10',
      discount: '10%',
    },

    {
      id: 2,
      name: 'WELCOME10',
      discount: '10%',
    },
    {
      id: 3,
      name: 'WELCOME10',
      discount: '10%',
    },
    {
      id: 4,
      name: 'WELCOME10',
      discount: '10%',
    },
  ];

  const updateStatus = async (id: string, flag: boolean) => {
    try {
      const body = {
        isBlocked: flag,
      };
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const res = await updatePromoCode({ body: encryptedBody, id }).unwrap();
      if (res?.statusCode === 200) {
        showToast('Promo code status change successfully.');
        setData((prev) =>
          prev.map((banner) => (banner._id === id ? { ...banner, isBlocked: flag } : banner))
        );
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    }
  };

  const handleDeletePromo = async () => {
    try {
      const res = await deletePromoCode({ id: selectedId }).unwrap();
      if (res?.statusCode === 200) {
        fetchPromos();
        // setData((pre) => pre?.filter((itx) => itx?._id !== selectedId));
        setSelectedId('');
        successToast('Promo Code deleted');
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    }
  };

  const columns: GridColDef<(typeof data)[number]>[] = [
    {
      flex: 1,
      minWidth: 100,
      field: 'name',
      headerName: 'Promo Code Name',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.name || ''}</p>
          </div>
        );
      },
    },
    // {
    //   flex: 1,
    //   minWidth: 300,
    //   field: "user",
    //   headerName: "Assigned to",
    //   editable: false,
    //   sortable: false,
    //   renderCell: () => {
    //     return (
    //       <div className="user_block">
    //         <figure >
    //           <img src="/static/images/user_attachment.jpg" alt="" />
    //         </figure>
    //         <p>
    //           <b>Emma Smith</b> +9203024595467 <br />
    //           emma@gmail.com
    //         </p>
    //       </div>
    //     );
    //   },
    // },

    {
      flex: 1,
      minWidth: 100,
      field: 'discount',
      headerName: 'Discount',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.discountPrice || ''}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: 'discount',
      headerName: 'Discount Type',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{DISCOUNT_TYPE_NAME[row?.type] || ''}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 200,
      field: 'status',
      filterable: false,
      sortable: false,
      headerName: 'Block/Unblock',
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={!row?.isBlocked}
            onChange={() => updateStatus(row?._id, !row?.isBlocked)}
          />
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'action',
      headerName: 'Action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? 'basic-menu1' : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? 'true' : undefined}
                onClick={(e) => {
                  handleClick1(e);
                  setSelectedId(row?._id);
                }}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  'aria-labelledby': 'basic-button1',
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.05)',
                    borderRadius: '8px',
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem
                  onClick={() => {
                    navigate(`view/${selectedId}`);
                    handleClose1();
                  }}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    navigate(`edit/${selectedId}`);
                    handleClose1();
                  }}
                >
                  Edit
                </MenuItem>

                <MenuItem
                  onClick={() => {
                    // setSelectedId(row?._id);
                    setOpenDelete(true);
                    handleClose1();
                  }}
                >
                  Delete
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const fetchPromos = async () => {
    try {
      setLoading(true);
      const res = await getPromoCode({
        limit: 10,
        page: page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (res?.statusCode === 200) {
        setTotalCount(res?.data?.count);
        setData(res?.data?.data);
      }
    } catch (error: any) {
      console.error(error);
      errorToast(error?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPromos();
  }, [page, searchTerm, debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Promo Codes</h1>
        <p>
          <span onClick={() => navigate('/dashboard')}>Dashboard</span> - Promo Codes
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: '100%' }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm('')}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_orange" onClick={() => navigate('add')}>
                  Add Promo Code
                </Button>
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns?.filter((item: any) => !hidden.includes(item.field))}
              rows={data}
              count={totalCount}
              page={page}
              loading={loading}
              onPageChange={handlePageChange}
            />
          </div>
        </Box>
      </div>
      <ConfirmationModal
        text={'Are you sure to delete this Promo Code ?'}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDeletePromo}
      />
    </MainContainer>
  );
};

export default ManagePromoCodes;
